<template>
<div class="param-copy-container">
    <!-- 操作按钮 -->
    <div class="copy-buttons ">
        <Button type="success" icon="ios-analytics-outline"
        :disabled="!sourceDevice || selectedItems.length === 0" @click="handleCompareParams" class="copy-button"
        :loading="compareLoading">
            {{ getTranslation("b060") }}
        </Button>&nbsp;
            <Button type="primary" icon="md-download" :disabled="!sourceDevice || selectedItems.length === 0"
        @click="handleCopyParams" class="copy-button" :loading="downloadLoading">
        {{ getTranslation("b059") }}
      </Button>

    </div>
    <Row type="flex" class="device-selection">
        <!-- 源设备选择 -->
        <Col flex="1">
        <Card class="source-device-card" dis-hover>
            <template #title>
                <div class="card-title">
                    <Icon type="ios-copy" />
                    <span>{{ getTranslation('b057') }} <span v-if="sourceDevice" class="selected-device-hint">({{ getDeviceName(sourceDevice) }})</span></span>
                </div>
            </template>
            <div class="tree-area">
                <Tree :key="'source-' + treeVersion" :data="sourceTreeData" :render="renderSourceContent"
                      @on-select-change="selectSource"
                      empty-text=""></Tree>
            </div>
        </Card>
        </Col>

        <!-- 目标设备选择 -->
        <Col flex="1">
        <Card class="target-device-card" dis-hover>
            <template #title>
                <div class="card-title">
                    <Icon type="ios-list" />
                    <span>{{ getTranslation('b058') }}</span>
                    <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll" size="default">
                        <span>{{ getTranslation('b056') }}</span>
                    </Checkbox>

                </div>
            </template>
            <div class="target-devices">
                <div class="tree-area target-tree-area">
                    <Tree :key="'target-' + treeVersion" :data="targetTreeData" :render="renderTargetContent"
                          show-checkbox
                          @on-check-change="onTargetCheck"
                          empty-text=""></Tree>
                </div>
            </div>
        </Card>
        </Col>
    </Row>

		<!-- 系统参数比较结果弹窗 -->
		<Modal v-model="compareModalVisible" :title="getTranslation('b004')" :fullscreen="true"  footer-hide :mask-closable="false">
			<div v-if="compareResults && compareResults.length >0" style="text-align:center;padding:0px 0;">
			<Row class="table-header" type="flex">
				<Col style="width: 200px; flex-shrink: 0;" class="table-header">{{ getTranslation("b065") }}</Col>
				<Col flex="1" class="table-header" v-if="compareSource && compareSource.code">{{ compareSource.code }}</Col>
				<Col flex="1" class="table-header" v-for="(oneCompare, oneRes) in filteredTargetResults" :key="'compare-source-' + oneRes">
				{{ oneCompare.target ? oneCompare.target.code : '' }}(<span class="group-diff-count">{{ getDiffCount(oneCompare) }}</span>)
				</Col>
			</Row>
			<Row v-if="compareResults && compareResults.length>0"  type="flex" >
				<Col flex="1">
				<Row v-for="(item,index) in compareResults[0].items" :key="index"  type="flex" :class="[ 'table-row',  ]">
					<Col style="width: 200px; flex-shrink: 0;" class="table-cell" >{{ item.Alias }}</Col>
					<Col flex="1" class="table-cell">{{ item.Original }}</Col>
					<Col flex="1" :class="[ 'table-cell',{ 'abnormal-row': !item.Same } ]">{{ item.Present }}</Col>
					<Col
						v-for="(oneCompare, oneRes) in filteredCompareResults"
						:key="'compare-' + oneRes + '-' + index"
						flex="1"
						:class="[ 'table-cell',{ 'abnormal-row': !oneCompare.items[index].Same } ]"
						>
						{{ oneCompare.items[index].Present }}
						</Col>
				</Row>
			</Col>
			</Row>

			</div>
		</Modal>

	</div>
</template>

<script>
import {
    API_URL
} from '@/constants/const.js'
import axios from 'axios';
import {
    postJsError
} from '@/util/util.js'

import {
    mapGetters
} from 'vuex';
export default {
    name: 'ParamCopy',
    components: {

    },
    props: {

    },
    data() {
        return {
            originData: [],
            selectedItems: [],
            checkAll: false,
            indeterminate: false,
            sourceDevice: null,
            compareModalVisible: false,
            compareLoading: false,
            compareResults: [],
            downloadLoading: false,
            compareSource: null,
            treeVersion: 1,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        macList() {
            const list = [];
            if (this.originData) {
                this.originData.forEach(line => {
                    if (line.machines && line.machines.length > 0) {
                        line.machines.forEach(m => list.push(m));
                    }
                });
            }
            return list;
        },
        sourceTreeData() {
            return this.buildTreeData(this.sourceDevice);
        },
        targetTreeData() {
            if (!this.originData) return [];
            return this.originData
                .filter(line => line.machines && line.machines.length > 0)
                .map(line => ({
                    id: line.id,
                    name: line.name,
                    expand: line.machines.some(m => this.selectedItems.includes(m.id)),
                    children: line.machines.map(m => ({
                        id: m.id,
                        name: m.code,
                        isMachine: true,
                        kind: m.kind,
                        checked: this.selectedItems.includes(m.id),
                        disabled: m.id === this.sourceDevice,
                    }))
                }));
        },
        filteredCompareResults() {
        // 过滤掉第一个元素，并且确保数据存在
        if (!this.compareResults || this.compareResults.length <= 1) {
            return []
        }
        return this.compareResults.filter((item, index) => index > 0 && item && item.items)
        },
        filteredTargetResults() {
        // 过滤掉第一个元素，并且确保数据存在
        if (!this.compareResults || this.compareResults.length < 1) {
            return []
        }
        return this.compareResults.filter((item) =>  item && item.target)
        }
    },
    watch: {

    },
    created() {
        this.init();
    },
    mounted() {

    },
    methods: {
        init() {
            this.getData();
        },
        getData() {
            let url = API_URL["productlineGetWithMachine"];
            axios.get(url, { timeout: 300000 })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.originData = res.data.data || [];
                        // 默认选中第一台设备作为源设备
                        const macList = [];
                        if (this.originData) {
                            this.originData.forEach(line => {
                                if (line.machines && line.machines.length > 0) {
                                    line.machines.forEach(m => macList.push(m));
                                }
                            });
                        }
                        if (macList.length > 0 && !this.sourceDevice) {
                            this.sourceDevice = macList[0].id;
                        }
                        this.treeVersion += 1;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('m041'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        buildTreeData(selectedId) {
            if (!this.originData) return [];
            return this.originData
                .filter(line => line.machines && line.machines.length > 0)
                .map(line => ({
                    id: line.id,
                    name: line.name,
                    expand: selectedId != null && line.machines.some(m => m.id === selectedId),
                    children: line.machines.map(m => ({
                        id: m.id,
                        name: m.code,
                        isMachine: true,
                        kind: m.kind,
                        selected: m.id === selectedId,
                    }))
                }));
        },
        selectSource(_selected, data) {
            if (!data || !data.isMachine) return;
            if (this.sourceDevice === data.id) return;
            this.sourceDevice = data.id;
            // 切换源设备时，清除目标设备中包含旧源设备的选择
            if (this.selectedItems.includes(this.sourceDevice)) {
                this.selectedItems = this.selectedItems.filter(id => id !== this.sourceDevice);
            }
            // 更新全选状态
            this.updateCheckAllState();
            this.treeVersion += 1;
        },
        toggleNode(node, data, e) {
            if (e) e.stopPropagation();
            if (data && Array.isArray(data.children) && data.children.length) {
                const next = !(data.expand === true);
                this.$set(data, 'expand', next);
                if (node && typeof node.expand !== 'undefined') node.expand = next;
            }
        },
        renderSourceContent(h, { node, data }) {
            let iconVNode;
            var title = data.name;
            let fontSize = '14px';
            let fontWeight = '500';
            if (data.isMachine) {
                // 机器节点：无状态圆点，保留缩进空间
                iconVNode = h('span', {
                    style: { marginRight: '8px', width: '10px', display: 'inline-block' }
                });
            } else {
                fontSize = '15px';
                fontWeight = '550';
                const isOpen = data.expand === true || node.expand === true;
                iconVNode = h('Icon', {
                    props: { type: isOpen ? 'md-arrow-dropdown' : 'md-arrow-dropright', size: 14 },
                    style: { marginRight: '4px', cursor: 'pointer', color: '#606266' },
                    on: {
                        click: (e) => {
                            e.stopPropagation();
                            this.toggleNode(node, data);
                        }
                    }
                });
            }

            let clickHandler = {
                click: () => {
                    if (!data.isMachine) {
                        this.toggleNode(node, data);
                    }
                }
            };

            return h('span', {
                on: clickHandler,
                style: { display: 'inline-block', width: '100%' },
                class: { 'tree-item': true, 'is-selected': data.selected === true }
            }, [
                h('span', [
                    h('span', { style: { cursor: 'pointer', display: 'inline-flex', alignItems: 'center' } }, [
                        iconVNode,
                        h('span', { style: { cursor: 'pointer', fontSize: fontSize, fontWeight: fontWeight } }, title)
                    ])
                ]),
                h('span', { style: { display: 'inline-block', float: 'right' } }, [

                ])
            ]);
        },
        renderTargetContent(h, { node, data }) {
            let iconVNode;
            var title = data.name;
            let fontSize = '14px';
            let fontWeight = '500';
            if (data.isMachine) {
                iconVNode = h('span', {
                    style: { marginRight: '8px', width: '10px', display: 'inline-block' }
                });
            } else {
                fontSize = '15px';
                fontWeight = '550';
                const isOpen = data.expand === true || node.expand === true;
                iconVNode = h('Icon', {
                    props: { type: isOpen ? 'md-arrow-dropdown' : 'md-arrow-dropright', size: 14 },
                    style: { marginRight: '4px', cursor: 'pointer', color: '#606266' },
                    on: {
                        click: (e) => {
                            e.stopPropagation();
                            this.toggleNode(node, data);
                        }
                    }
                });
            }

            let clickHandler = {
                click: () => {
                    if (!data.isMachine) {
                        this.toggleNode(node, data);
                    }
                }
            };

            return h('span', {
                on: clickHandler,
                style: { display: 'inline-block', width: '100%' },
                class: { 'tree-item': true, 'is-disabled-tree': data.disabled === true }
            }, [
                h('span', [
                    h('span', { style: { cursor: data.disabled ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' } }, [
                        iconVNode,
                        h('span', { style: { cursor: data.disabled ? 'not-allowed' : 'pointer', fontSize: fontSize, fontWeight: fontWeight, color: data.disabled ? '#c5c8ce' : '' } }, title)
                    ])
                ]),
                h('span', { style: { display: 'inline-block', float: 'right' } }, [

                ])
            ]);
        },
        onTargetCheck(checkedNodes) {
            // 过滤出机器节点
            this.selectedItems = checkedNodes
                .filter(node => node.isMachine && !node.disabled)
                .map(node => node.id);
            this.updateCheckAllState();
        },
        updateCheckAllState() {
            const totalEligible = this.macList.filter(item => item.id !== this.sourceDevice).length;
            this.checkAll = this.selectedItems.length === totalEligible && totalEligible > 0;
            this.indeterminate = this.selectedItems.length > 0 && this.selectedItems.length < totalEligible;
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                this.selectedItems = this.macList
                    .filter(item => item.id !== this.sourceDevice)
                    .map(item => item.id);
            } else {
                this.selectedItems = [];
            }
            this.treeVersion += 1; // force tree re-render
        },

        getDeviceName(deviceId) {
            const device = this.macList.find(item => item.id === deviceId);
            return device ? device.code : '';
        },

        async handleCopyParams() {
            if (!this.sourceDevice || this.selectedItems.length === 0) {
                this.$Message.warning(this.getTranslation('b134'));
                return;
            }
            this.downloadLoading = true;
            this.$Modal.confirm({
                title: this.getTranslation('b135'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                content: this.getTranslation('b137') + this.getDeviceName(this.sourceDevice) + this.getTranslation('b138'),
                 onOk: async() => {
                    let url = API_URL["libraryCopyPost"];
                    let formData = new FormData();
                    formData.append('mac', this.sourceDevice);
                    formData.append('items', this.selectedItems.join(','));
                    let res = await axios.post(url,
                            formData,{timeout: 300000}
                        )
                        .catch((err) => {
                            this.downloadLoading = false;
                            postJsError(err)
                            return;
                        })
                        if (res && res.data && res.data.code == 200) {
                            this.$Message.success(res.data.msg);
                        } else if (res && res.data && res.data.msg) {
                            this.$Message.error(res.data.msg);
                        } else {
                            this.$Message.error(this.getTranslation('c001'));
                        }
                        this.downloadLoading = false;
                    },
                    onCancel: () => {
                        this.downloadLoading = false;
                    }

            });

        },
        async handleCompareParams() {
            if (!this.sourceDevice || this.selectedItems.length === 0) {
                this.$Message.warning(this.getTranslation('b134'));
                return;
            }

            this.compareLoading = true;
            this.compareResults = [];


            let url = API_URL["librarySystemCompare"];
            let formData = new FormData();
            formData.append('mac', this.sourceDevice);
            formData.append('items', this.selectedItems.join(','));
            let res = await axios.post(url,
                formData,{timeout: 300000}
            ).catch((err) => {
                postJsError(err)
                this.compareLoading = false;
            })
            if (res && res.data && res.data.code == 200) {
                this.compareModalVisible = true;
                let data = res.data.data;
                this.compareResults = data.comparisons || [];
                this.compareSource = data.source || null;

            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
            this.compareLoading = false;
        },

        rowClassName(row) {
            if (!row.Same) {
                return 'compare-diff-row';
            }
            return '';
        },
        getDiffCount(group) {
        if (!group.items) return ''
        const diffCount = group.items.filter(item => !item.Same).length
        return diffCount > 0 ? diffCount + ' '+this.getTranslation('p085') : this.getTranslation('p086')
        },

    }

}
</script>

<style scoped>
@import url("../../../assets/style/list.css");
@import url("../../../assets/style/tab.css");
.param-copy-container {
    padding: 20px;
    margin: 0 auto;
}

.device-selection {
    margin-bottom: 24px;
    width: 100%
}

.source-device-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.target-device-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-title i {
    font-size: 18px;
    color: #2d8cf0;
}

.selected-device-hint {
    font-size: 13px;
    color: #808695;
    font-weight: normal;
}

.tree-area {
    height: 420px;
    overflow-y: auto;
    overflow-x:hidden;
    margin-bottom: 12px;
    padding: 4px 0;
    border: 1px solid #dcdee2;
    border-radius: 6px;
}

.device-selector {
    padding: 16px 0;
}

.device-select {
    width: 100%;
    margin-bottom: 12px;
}

.select-all-section {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8eaec;
}

.copy-buttons {
    text-align: center;
    margin: 10px 0;
}

.copy-button {
    margin-right: 12px;
    min-width: 160px;
    height: 30px;
    font-size: 14px;
}

/* 比较结果样式 */
:deep(.compare-diff-row td) {
    color: #ed4014 !important;
    font-weight: bold;
    background-color: #fff2f0 !important;
}
.abnormal-row {
  background-color: #fff2f0 !important;
  border-left: 3px solid #ff4d4f;
}

.abnormal-row .table-cell {
  color: #ff4d4f;
}

/* 树状选择样式 */
.tree-item {
    display: inline-block;
    width: 100%;
    border-radius: 0;
    transition: background 0.15s ease, color 0.15s ease;
    padding: 0 4px;
}

.tree-item.is-selected {
    background: #bae7ff;
    color: #1890ff;
    border-radius: 0;
    padding: 0 4px 0 4px;
    font-weight: 550;
    transition: background 0.2s ease, color 0.2s ease;
}

.tree-item.is-disabled-tree {
    opacity: 0.55;
}

.tree-area :deep(.ivu-tree-title) {
    width: 100%;
}

.tree-area :deep(.ivu-tree-title:hover) {
    background: #bae7ff;
    transform: scale(1.02);
    transition: background 0.2s ease, transform 0.2s ease;
    color: #333333;
    border-radius: 4px;
    padding: 0 0;
    box-sizing: border-box;
}

.tree-area :deep(.ivu-tree-arrow) {
    display: none;
}
</style>
